import { Mail } from "lucide-react";
import { Link, useSearchParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md border-white/70 shadow-xl shadow-slate-900/10">
        <CardHeader className="text-center">
          <img src="/brand/logo.png" alt="VELUX" className="mx-auto mb-4 h-10 w-auto" />
          <div className="bg-primary/10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <Mail className="text-primary h-8 w-8" />
          </div>
          <CardTitle className="font-heading text-primary text-2xl font-bold">
            Check your email
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted mb-6">
            We&apos;ve sent a verification link to{" "}
            {email ? (
              <span className="text-foreground font-medium">{email}</span>
            ) : (
              "your email address"
            )}
            . Please click the link to verify your account before signing in.
          </p>
          <p className="text-muted mb-6 text-sm">
            Didn&apos;t receive the email? Check spam or request a new verification to continue your
            MPC setup.
          </p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">Back to sign in</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
